// extracted by mini-css-extract-plugin
export var attributeContainer = "SpecsGroup-module--attributeContainer--h4iWa";
export var specGroupContainer = "SpecsGroup-module--specGroupContainer--hhSQj";
export var specificationTitleList = "SpecsGroup-module--specificationTitleList--dHUzq";
export var groupName = "SpecsGroup-module--groupName--tL5Si";
export var groupActive = "SpecsGroup-module--groupActive--U32hj";
export var label = "SpecsGroup-module--label--HTAlL";
export var active = "SpecsGroup-module--active--i0n7t";